import { Link } from "react-router-dom";
import { QrCode, MonitorSmartphone, LayoutDashboard } from "lucide-react";
import { BrandLogo } from "../components/BrandLogo";

const HERO = "https://images.unsplash.com/photo-1588644525273-f37b60d78512?w=1400&q=70&auto=format&fit=crop";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FAF6F0] text-stone-900" data-testid="landing-page">
      <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
        <div className="flex flex-col justify-between px-6 py-10 sm:px-12 lg:px-16">
          <BrandLogo to="/" />
          <div className="max-w-xl py-16">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF9D05]">QR ordering for India</p>
            <h1 className="mt-4 text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">Scan. Order. Pay.<br />Kitchen knows in a second.</h1>
            <p className="mt-6 max-w-md text-base text-stone-600">Guests order from the table with nothing to install. Staff get a live queue, the kitchen gets tickets, and you get GST bills and reports.</p>
            <div className="mt-10 grid gap-3 sm:grid-cols-3">
              <Tile to="/m/demo-t1" icon={QrCode} title="Guest menu" sub="Demo Café · Table T1" testid="landing-guest-link" primary />
              <Tile to="/staff" icon={MonitorSmartphone} title="Staff app" sub="Orders & kitchen" testid="landing-staff-link" />
              <Tile to="/admin" icon={LayoutDashboard} title="Restaurant owner login" sub="Menu, staff, reports" testid="landing-admin-link" />
            </div>
          </div>
          <p className="text-xs text-stone-500">Powered by Arismeta</p>
        </div>
        <div className="relative hidden lg:block">
          <img src={HERO} alt="Indian thali" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute bottom-10 left-10 rounded-2xl bg-[#1C1917]/85 p-5 text-white backdrop-blur-md">
            <p className="font-mono text-[10px] uppercase tracking-widest text-orange-200">Table T4 · just now</p>
            <p className="mt-1 font-display text-2xl font-bold">Order #128 is ready</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function Tile({ to, icon: Icon, title, sub, testid, primary }) {
  return (
    <Link to={to} data-testid={testid} className={`group rounded-2xl border-2 p-4 transition-transform hover:-translate-y-0.5 ${primary ? "border-[#FF9D05] bg-[#FF9D05] text-white" : "border-stone-900 bg-white"}`}>
      <Icon className="h-5 w-5" />
      <p className="mt-6 font-bold">{title}</p>
      <p className={`text-xs ${primary ? "text-orange-100" : "text-stone-500"}`}>{sub}</p>
    </Link>
  );
}
